export default __webpack_public_path__ + "98f8586d864a11c3dec5a6b9da460140.svg";